
        import * as module0 from './controllers/example_controller.js';import * as module1 from './controllers/navbar_controller.js';import * as module2 from './controllers/story_controller.js'
        const modules = {
            "./controllers/example_controller.js": module0,
            "./controllers/navbar_controller.js": module1,
            "./controllers/story_controller.js": module2,
        };
        export default modules;
      